import {
  REQUEST_PROFITSTATISTICS,
  REQUEST_PROFITSTATISTICS_DONE,
  ProfitStatisticsActions
} from "./types";
import { ProfitStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchProfitStatistics(): ProfitStatisticsActions {
  return {
    type: REQUEST_PROFITSTATISTICS,
    payload: []
  };
}

function fetchProfitStatisticsDone(
  ProfitStatistics: ReadonlyArray<ProfitStatistics>
): ProfitStatisticsActions {
  return {
    type: REQUEST_PROFITSTATISTICS_DONE,
    payload: ProfitStatistics
  };
}

/* Thunks goes here */
export const thunkFetchProfitStatistics = (
  periodFrom: Date,
  periodTo: Date
) => async (dispatch: any) => {
  try {
    dispatch(fetchProfitStatistics());
    const result = await StatisticsApi.getProfitStatistics(
      periodFrom,
      periodTo
    );

    if (isOk(result)) {
      dispatch(fetchProfitStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchProfitStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
